import React from 'react'
import { CreditInfoStepsContextProvider } from '../../context/creditInfoStepsContext'
import { CreditInfoStepRoutes } from '../../routes/creditinfoForm/creditinfoRoutes'

export default function CreditInfoWithStepsContext() {
  return (
    <CreditInfoStepsContextProvider>
      <CreditInfoStepRoutes />
    </CreditInfoStepsContextProvider>
  )
}
